import * as tslib_1 from "tslib";
import * as React from 'react';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import controlStrings from 'owa-strings/owa-common-strings';
var spriteStyles = require('owa-sprite/dist/styles/ribbon_sprite.css');
var styles = require('./MessageFormatFull.scss');
var classNames = require('classnames/bind').bind(styles);
var FormatButton = /** @class */ (function (_super) {
    tslib_1.__extends(FormatButton, _super);
    function FormatButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onClick = function () {
            if (_this.props.onClick) {
                _this.props.onClick(!_this.props.isSelected);
            }
        };
        return _this;
    }
    FormatButton.prototype.render = function () {
        return (React.createElement(Button, { buttonType: ButtonType.icon, type: this.props.type, className: classNames(styles.formatButton, {
                isSelected: this.props.isSelected,
            }), "data-is-focusable": true, title: controlStrings[this.props.type], onClick: this.onClick },
            React.createElement("span", { className: spriteStyles["ribbon-icon-" + this.props.type] })));
    };
    return FormatButton;
}(React.Component));
export default FormatButton;
//# sourceMappingURL=FormatButton.js.map